import {
  SIGNALTEK_POST_RESULTS,
  SIGNALTEK_CLEAR_RESULTS,
  SETSIGNALTEK,
  CLEARSIGNALTEK,
  SUBTEST_SUBTESTSETTINGS_RESULTS,
  CLEAR_SUBTESTSETTINGS_RESULTS
} from "../actions/resultActions";
const POST_RESULTS_SUCCESS = "POST_RESULTS_SUCCESS";
const POST_RESULTS_FAIL = "POST_RESULTS_FAIL";
const SUBTEST_RESULTS_SUCCESS = "SUBTEST_RESULTS_SUCCESS";
const SUBTEST_RESULTS_FAIL = "SUBTEST_RESULTS_FAIL";
const SUBTEST_RESULTS_RESET = "SUBTEST_RESULTS_RESET";
const SUBTEST_RESULTS_PREF_SET = "SUBTEST_RESULTS_PREF_SET";
const RESET_RESULTS = "RESET_RESULTS";
export const HIDE_RESULTS = "HIDE_RESULTS";
export const HIDE_RESULT_HEADERS = "HIDE_RESULT_HEADERS";
export const CLEAR_RESULTS = "CLEAR_RESULTS";
const SUCCESS = "_SUCCESS";
const FAIL = "_FAIL";
const SUBTEST_SIGNALTEK_RESULTS_SUCCESS = "SUBTEST_SIGNALTEK_RESULTS_SUCCESS";
const SUBTEST_SIGNALTEK_RESULTS_FAIL = "SUBTEST_SIGNALTEK_RESULTS_FAIL";
const GET_NETSCAN_RESULT_SUCCESS = "GET_NETSCAN_RESULT_SUCCESS";
const GET_NETSCAN_RESULT_FAIL = "GET_NETSCAN_RESULT_FAIL";
const SUBTEST_WIREMAP_RESULTS_SUCCESS = "SUBTEST_WIREMAP_RESULTS_SUCCESS";
const SUBTEST_WIREMAP_RESULTS_FAIL = "SUBTEST_WIREMAP_RESULTS_FAIL";
const WIREMAP_RESULTS_LOADED = "WIREMAP_RESULTS_LOADED";
const SUBTEST_FIBER_LENGTH_LOSS_RESULTS_SUCCESS = "SUBTEST_FIBER_LENGTH_LOSS_RESULTS_SUCCESS";
const SUBTEST_FIBER_LENGTH_LOSS_RESULTS_FAIL = "SUBTEST_FIBER_LENGTH_LOSS_RESULTS_FAIL";
const SUBTEST_POE_RESULTS_SUCCESS = "SUBTEST_POE_RESULTS_SUCCESS";
const SUBTEST_POE_RESULTS_FAIL = "SUBTEST_POE_RESULTS_FAIL";
const SUBTEST_MAXTHROUGHPUT_RESULTS_SUCCESS =
  "SUBTEST_MAXTHROUGHPUT_RESULTS_SUCCESS";
const SUBTEST_MAXTHROUGHPUT_RESULTS_FAIL = "SUBTEST_MAXTHROUGHPUT_RESULTS_FAIL";
const SUBTEST_UPTIME_RESULTS_SUCCESS = "SUBTEST_UPTIME_RESULTS_SUCCESS";
const SUBTEST_UPTIME_RESULTS_FAIL = "SUBTEST_UPTIME_RESULTS_FAIL";
const SUBTEST_UPTIME_RESULTS_DETAILS_SUCCESS =
  "SUBTEST_UPTIME_RESULTS_DETAILS_SUCCESS";
const SUBTEST_UPTIME_RESULTS_DETAILS_FAIL =
  "SUBTEST_UPTIME_RESULTS_DETAILS_FAIL";

const SUBTEST_UPTIME_RESULTS_BAR_CLICK_SUCCESS =
  "SUBTEST_UPTIME_RESULTS_BAR_CLICK_SUCCESS";
const SUBTEST_UPTIME_RESULTS_BAR_CLICK_FAIL =
  "SUBTEST_UPTIME_RESULTS_BAR_CLICK_FAIL";
const GET_STATS_RESULT_SUCCESS = "GET_STATS_RESULT_SUCCESS";
const GET_STATS_RESULT_FAIL = "GET_STATS_RESULT_FAIL";

export const defaultResultState = {
  results: null,
  signaltekResults: null,
  subtestResultsWiremap: null,
  subtestResultsRemote: [],
  subtestResultsDisplay: [],
  preferences: {
    chartLineStyle: "inverted",
    chartMeasurement: "auto",
    showMargin: true,
    wiremapStandard: "Standard"
  },
  showResults: false,
  showResultHeader: false,
  isSignaltek: false,
  subtestSubTestSettingsResults: null,
  subtestSignaltekResults: null
};

export default (state = defaultResultState, action) => {
  switch (action.type) {
    case POST_RESULTS_SUCCESS:
      return {
        ...state,
        results: action.payload.data,
        showResults: true,
        showResultHeader: true
      };
    case POST_RESULTS_FAIL:
      return {
        ...state,
        showResults: true,
        showResultHeader: true
      };
    case SUBTEST_RESULTS_SUCCESS:
      const subtest =
        action.meta.previousAction.payload.request.data.request.subtesttypeid;
      let { subtestResultsDisplay, subtestResultsRemote } = state;

      subtestResultsDisplay = [];
      subtestResultsRemote = [];

      subtestResultsDisplay[subtest] = subtestResultsDisplay[subtest] || null;
      subtestResultsRemote[subtest] = subtestResultsRemote[subtest] || null;
      if (
        action.meta.previousAction.payload.request.data.request
          .subtesttypeid === "Wiremap"
      ) {
        return {
          ...state,
          subtestResultsWiremap: action.payload.data.WireData
        };
      }
      if (
        action.meta.previousAction.payload.request.data.request.handsettype ===
        0
      ) {
        subtestResultsDisplay[subtest] = action.payload.data.success
          ? action.payload.data
          : null;
        return {
          ...state,
          subtestResultsDisplay
        };
      } else if (
        action.meta.previousAction.payload.request.data.request.handsettype ===
        1
      ) {
        subtestResultsRemote[subtest] = action.payload.data.success
          ? action.payload.data
          : null;
        return {
          ...state,
          subtestResultsRemote
        };
      }

    case SUBTEST_RESULTS_FAIL:
      return {
        ...state
      };
    case SUBTEST_RESULTS_RESET:
      return {
        ...state,
        subtestResultsRemote: [],
        subtestResultsDisplay: [],
        subtestSignaltekResults: {},
      };

    case SUBTEST_RESULTS_PREF_SET:
      return {
        ...state,
        preferences: action.data
      };

    case RESET_RESULTS:
      return {
        ...state,
        subtestSignaltekResults: {},
        subtestResultsWiremap: null,
        subtestResultsRemote: [],
        subtestResultsDisplay: []
      };
    case HIDE_RESULTS: {
      return {
        ...state,
        showResults: false
      };
    }
    case HIDE_RESULT_HEADERS: {
      return {
        ...state,
        showResultHeader: false
      };
    }
    case CLEAR_RESULTS: {
      return {
        ...state,
        results: null
      };
    }
    case SIGNALTEK_POST_RESULTS + SUCCESS: {
      return {
        ...state,
        signaltekResults: action.payload.data,
        showResults: true,
        showResultHeader: true
      };
    }
    case SIGNALTEK_POST_RESULTS + FAIL: {
      return {
        ...state,
        showResults: true,
        showResultHeader: true
      };
    }
    case SIGNALTEK_CLEAR_RESULTS: {
      return {
        ...state,
        signaltekResults: null,
        subtestSignaltekResults: null
      };
    }
    case SUBTEST_SIGNALTEK_RESULTS_SUCCESS: {
      return {
        ...state,
        subtestSignaltekResults: action.payload.data,
      };
    }
    case SUBTEST_SIGNALTEK_RESULTS_FAIL:
      return {
        ...state
      };
    case CLEARSIGNALTEK: {
      return {
        ...state,
        isSignaltek: false
      };
    }
    case SETSIGNALTEK: {
      return {
        ...state,
        isSignaltek: true
      };
    }
    case GET_NETSCAN_RESULT_SUCCESS: {
      return {
        ...state,
        netScanResultDetail: action.payload.data
      };
    }
    case GET_NETSCAN_RESULT_FAIL:
      return {
        ...state
      };
    case SUBTEST_WIREMAP_RESULTS_SUCCESS: {
      return {
        ...state,
        subtestWiremapResults: action.payload.data
      };
    }
    case SUBTEST_WIREMAP_RESULTS_FAIL:
      return {
        ...state
      };
    case WIREMAP_RESULTS_LOADED: {
      return {
        ...state,
        created: false,
        subtestWiremapResults: action.data.subtestWiremapResults,
        error: false
      };
    }
    case SUBTEST_FIBER_LENGTH_LOSS_RESULTS_SUCCESS: {
      return {
        ...state,
        subtestFiberLengthLossResults: action.payload.data
      };
    }
    case SUBTEST_FIBER_LENGTH_LOSS_RESULTS_FAIL:
      return {
        ...state
      };
    case SUBTEST_POE_RESULTS_SUCCESS: {
      return {
        ...state,
        subtestPoeResults: action.payload.data
      };
    }
    case SUBTEST_POE_RESULTS_FAIL:
      return {
        ...state
      };

    case SUBTEST_MAXTHROUGHPUT_RESULTS_SUCCESS: {
      return {
        ...state,
        subtestMaxthroughputResults: action.payload.data
      };
    }
    case SUBTEST_MAXTHROUGHPUT_RESULTS_FAIL:
      return {
        ...state
      };
    case SUBTEST_UPTIME_RESULTS_SUCCESS: {
      return {
        ...state,
        subtestUptimeResults: action.payload.data
      };
    }
    case SUBTEST_UPTIME_RESULTS_FAIL:
      return {
        ...state
      };
    case SUBTEST_UPTIME_RESULTS_DETAILS_SUCCESS: {
      return {
        ...state,
        subtestUptimeResultsDetails: action.payload.data
      };
    }
    case SUBTEST_UPTIME_RESULTS_DETAILS_FAIL:
      return {
        ...state
      };
    case SUBTEST_UPTIME_RESULTS_BAR_CLICK_SUCCESS: {
      return {
        ...state,
        subtestUptimeResultsDetails_BarClick: action.payload.data
      };
    }
    case SUBTEST_UPTIME_RESULTS_BAR_CLICK_FAIL:
      return {
        ...state
      };

    case SUBTEST_SUBTESTSETTINGS_RESULTS + SUCCESS: {
      return {
        ...state,
        subtestSubTestSettingsResults: action.payload.data
      };
    }
    case SUBTEST_SUBTESTSETTINGS_RESULTS + FAIL: {
      return {
        ...state
      };
    }
    case CLEAR_SUBTESTSETTINGS_RESULTS: {
      return {
        ...state,
        subtestSubTestSettingsResults: null
      };
    }
    case GET_STATS_RESULT_SUCCESS: {
      return {
        ...state,
        subtestStatsResults: action.payload.data
      };
    }
    case GET_STATS_RESULT_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
};
